import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Menu from '../components/Menu';
import { signOut } from '../actions';
import * as rootObject from '../reducers';

const mapStateToProps = (state, ownProps) => {
	
	return {
		...ownProps,
		isSignedIn:!!rootObject.getUser(state).id,
		online:rootObject.getOnlineStatus(state)
	};
}

const mapDispatchToProps = {
	doSignOut:signOut
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(Menu))


// WEBPACK FOOTER //
// ./src/containers/MenuContainer.js